<template>
  <div class="modal-wrapper" @click.self="closeModal()">
    <transition name="zoom-in">
      <div class="modal" :class="{'modal--pdf': media.type === 'pdf' }" v-if="opened">
        <iframe v-if="media.type === 'pdf'" :src="media.url" class="pdf"></iframe>
        <img v-else-if="media.type === 'image'" :src="media.url" alt="Large image">
        <video v-else-if="media.type === 'video'" controls autoplay>
          <source :src="media.url" type="video/mp4">Your browser does not support the video tag.
        </video>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["media"],
  data() {
    return {
      opened: false
    };
  },
  methods: {
    closeModal() {
      this.opened = false;
      setTimeout(() => {
        this.$emit("close-media-modal");
        this.$parent.$emit("close-media-modal");
      }, 200);
    },
    handleEsc(e) {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.opened = true;
    }, 200);

    document.addEventListener("keyup", this.handleEsc);
  },
  destroyed() {
    document.removeEventListener("keyup", this.handleEsc);
  }
};
</script>

<style lang="scss" scoped>
.modal {
  padding: 10px;
  width: calc(90% - 10px);

&.modal--pdf {
  aspect-ratio: 1 / 36;
  overflow: hidden;

  iframe{
    height: 100%;
    width: 100%;
  }
}
  
  img,
  video {
    width: 100%;
  }
}

@media screen and (max-width: 1000px) {
  .modal {
    width: 80vw;
  }
}
</style>
